import React, { type MouseEventHandler } from "react";
import { KatBadge } from "@amzn/katal-react";
import { useTranslation } from "react-i18next";
import { TestStatus } from "src/api/interfaces/nest";
import "./index.css";

const statusConfig = {
  [TestStatus.PASS]: {
    label: "aic_nest_status_pass",
    variant: "success",
  },
  [TestStatus.FAIL]: {
    label: "aic_nest_status_fail",
    variant: "danger",
  },
  [TestStatus.NO_DATA]: {
    label: "aic_nest_status_no_data",
    variant: "default",
  },
} as const;

interface NestStatusBadgeProps {
  status: TestStatus;
  className?: string;
  onClick?: MouseEventHandler<KatBadge.Element>;
}

export function NestStatusBadge({
  status,
  className,
  onClick,
}: NestStatusBadgeProps) {
  const { t } = useTranslation();
  const config = statusConfig[status] ?? statusConfig[TestStatus.NO_DATA];
  const classNameInternal = className ?? "";

  return (
    <KatBadge
      className={`nest-status-badge ${classNameInternal}`}
      label={t(config.label)}
      type={config.variant}
      onClick={onClick}
    />
  );
}
